// calibrationLogsList/calibrationLogsListState.js

export const calibrationLogsListInitialState = {
  active: {
    isLoading: true,
    error: null,
    items: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalBooks: 0,
      booksPerPage: 10,
    },
    selectedId: null,
  },
  completed: {
    isLoading: true,
    error: null,
    items: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalBooks: 0,
      booksPerPage: 10,
    },
    selectedId: null,
  },
};
